import { DELETE_CONTACT, GET_CONTACT, SET_CONTACT } from "./actionType";

export const setContact = (contact) => {
  return {
    type: SET_CONTACT,
    payload: contact,
  };
};

export const getContact = (contactData) => {
  return {
    type: GET_CONTACT,
    payload: contactData,
  };
};

export const deleteContact = (id) => {
  return {
    type: DELETE_CONTACT,
    payload: id,
  }
}
